import { Button, Chip, Stack } from '@citibox-panel/ui';
import type { LocationFilters } from '../../search-shell/model/shellState';
import { deliveryRangeLabel } from '../../../lib/deliveryRange';
import { deliveryStateChipLabel } from '../../../lib/deliveryStates';

export interface LocationFilterChipsProps {
  filters: LocationFilters;
  onEdit: () => void;
}

export function LocationFilterChips({ filters, onEdit }: LocationFilterChipsProps) {
  return (
    // Wrapping, not one unbreakable row: a chip naming several states is long, and without this it
    // SQUEEZES its neighbours instead of dropping to the next line.
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
      {/* `box` arrives absent or non-empty — the filter form omits a blank one and the URL schema
          rejects a stored one — so presence alone is «a box filter is applied». */}
      {/* TODO: i18n */}
      {filters.box !== undefined && <Chip kind="mark" label={`Buzón: ${filters.box}`} />}
      {/* The stored display label, never the id the query is keyed by: a tab restored from the URL
          has to name its carrier on sight, and an id cannot without a read nobody designed a
          loading state for. Gated on the LABEL and not on `carrier`, so the chip can never be
          there with nothing to say; absent is «Todos los carriers» and takes no space at all. */}
      {filters.carrierLabel !== undefined && <Chip kind="mark" label={filters.carrierLabel} />}
      {/* Labelled by the very function that paints the state cell of every row, so the chip and the
          rows it describes cannot say different words for one state. Read from the care lib and NOT
          from the filter form's option builder, which lives in the other slice — the labels are
          shared vocabulary, the option list is not.
          Named in the order the filter set stores, which is the canonical one: re-ordering here by
          label would need that other slice's sort, and the chip does not get to disagree with the
          array the query was keyed by.
          Bare state names, with no «Estado:» prefix: the labels name the filter on sight, just as
          the carrier chip beside them does, and the prefix only spent the width the long
          enumerations need. TODO: i18n */}
      {filters.states !== undefined && (
        <Chip kind="mark" label={filters.states.map(deliveryStateChipLabel).join(', ')} />
      )}
      {/* Derived from the helper the filter form builds its options from — one definition, so this
          can never claim a range the query did not use. */}
      <Chip kind="mark" label={deliveryRangeLabel(filters.days)} />
      {/* The chips are labels, not controls; this is the whole affordance for changing them. A quiet
          action rather than an underlined link, in step with «Cambiar» in the dialog it reopens: an
          underline at the end of a row of chips reads as one more label, and the two controls are
          one decision. `sentenceCase` because the `link` look carried it for free — without the prop
          this would come back as «EDITAR» and the pair would disagree on casing instead. */}
      {/* TODO: i18n */}
      <Button variant="text" sentenceCase onClick={onEdit}>
        Editar
      </Button>
    </Stack>
  );
}
